import { IonIcon } from "@ionic/react";
import { chevronDownOutline } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";

// Styled Components
const DropdownContainer = styled.div<any>`
	position: relative;
	display: inline-block;
	width: max-content;
	${(props) =>
		props.isDisabled &&
		css`
			opacity: 0.5;
			pointer-events: none;
		`}
`;

const DropdownHeader = styled.div<any>`
	padding: ${props => props.isListEmpty ? "" : "10px 10px 10px 0"};
	background-color: transparent;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #FFF;
	font-weight: 600;
`;

const DropdownList = styled.ul<any>`
	list-style: none;
	padding: 0;
	margin: 0;
	position: absolute;
	width: 100%;
	background: #4b4b4b;
	border-radius: 4px;
	max-height: ${({ isOpen }) => (isOpen ? "300px" : "0px")};
	transition: max-height 0.3s ease-in-out;
	overflow-y: auto;
	z-index: 113;
`;

const DropdownItem = styled.li<any>`
	padding: 10px;
	cursor: pointer;
	text-align: left;
	color: ${({ theme, isActive }) => (isActive ? "#ffcc00" : theme.colors.main.text)};
	&:hover {
		background-color: transparent;
	}
`;

const Arrow = styled(IonIcon)<any>`
	width: 18px;
	height: 18px;
	color: #FFF;
	margin: 0 0 0 10px;
	transform: ${({ isOpen }) => (isOpen ? "rotate(-180deg)" : "rotate(0deg)")};
	transition: transform 0.2s ease;
`;

const NoItemsMessage = styled.div`
	padding: 10px;
	text-align: center;
	color: #fff;
`;

// Dropdown Component=
const Dropdown = ({
	items,
	placeholder = "Select an item",
	onSelect,
	selectedItem,
	noItemsText = "No items available",
	isDisabled,
}: any) => {
	const [isOpen, setIsOpen] = useState(false);
	const isListEmpty = items.length === 0;

	const handleToggle = () => {
		if(isListEmpty) return;
		setIsOpen(!isOpen);
	};

	const handleSelect = (item: any) => {
		setIsOpen(false); // Close dropdown on selection
		onSelect(item);
	};

	return (
		<DropdownContainer isDisabled={isDisabled}>
			<DropdownHeader isListEmpty={isListEmpty} onClick={handleToggle}>
				<span>{selectedItem.value ? selectedItem.label : placeholder}</span>
				{!isListEmpty ? <Arrow isOpen={isOpen} src={chevronDownOutline} /> : "" }
			</DropdownHeader>
			<DropdownList isOpen={isOpen} className="no-scrollbar">
				{!isListEmpty ? (
					items.map((item: any) => {
						const isActive = selectedItem.value === item.value;
						return (
							<DropdownItem isActive={isActive} key={item.value} onClick={() => {
								if(isActive) return;
								handleSelect(item)
							}}>
								{item.label}
							</DropdownItem>
						);
					})
				) : (
					<NoItemsMessage>{noItemsText}</NoItemsMessage>
				)}
			</DropdownList>
		</DropdownContainer>
	);
};

export default Dropdown;
